import $models from '@/models'
import util from '@/util'

import { goal_create, goal_add_member } from './goal'
import { commitment_create } from './commitment'
import { invitation_send_to_existing_user } from './invitation'
import { task_create_user, task_assign_to_goal } from './task';

const $userContact = $models.userContact

// -----------------------------------------------------------------------------
export function contact_add({ contactUserId }) {

  // Wenn Freunschaftsanfrage:
  // 1. add user to my contact list
  // 2. mark as unconfirmed?

  if ( !util.isValidId( contactUserId ) ) {
    throw new Error('Invalid contactUserId: ' + contactUserId)
  }

  return $userContact
    .add({
      contactUserId: contactUserId
    }, contactUserId)
}

// -----------------------------------------------------------------------------
export function contact_rem({ contactUserId }) {

  if ( !util.isValidId( contactUserId ) ) {
    throw new Error('Invalid contactUserId: ' + contactUserId)
  }

  let myUserId = $models.user.defaultUserId;

  let p1 = $userContact.remove(contactUserId)
  let p2 = $userContact.with({ uid: contactUserId }).remove(myUserId)

  return Promise.all([p1, p2])
}

// -----------------------------------------------------------------------------
export function contact_send_friend_request({ contactUserId }) {
  // See UserInvite.vue
}

// -----------------------------------------------------------------------------
export function contact_accept_or_decline_friend_request({ contactUserId, accept }) {

  if ( accept ) {
    // 1. add user to my contact list
    let promise = contact_add({ contactUserId });

    // 2.
    // ...

    return promise;
  } else {
    return Promise.resolve();
  }
}

// -----------------------------------------------------------------------------
export function contact_update_settings({ contactUserId, allowInterrupt, allowDropTasks }) {

  // REMOVE: not needed

  if ( !util.isValidId( contactUserId ) ) {
    throw new Error('Invalid contactUserId: ' + contactUserId)
  }

  $userContact
    .with({ uid: contactUserId })
    .update(contactUserId, {
      allowInterrupt: allowInterrupt,
      allowDropTasks: allowDropTasks,
    })
}

// -----------------------------------------------------------------------------
export function contact_create_shared_goal({ contactUserId, name }) {

  console.log("contact_create_shared_goal", contactUserId, name)

  const picture = 'https://images.pexels.com/photos/1086584/pexels-photo-1086584.jpeg?auto=format%2Ccompress&cs=tinysrgb&dpr=2&h=750&w=1260';
  const senderUserId = $models.user.defaultUserId;

  return goal_create({
    name,
    picture,
    isTeamgoal: true,
    dataMeta: null,
    dataUser: {},
    userPublic: null
  }).then((sharedGoalId) => {

    console.log("Got sharedGoalId", sharedGoalId)

    // TODO: Chain promises

    // Invite other user
    let invitationPayload = {
      goalId: sharedGoalId,
      cachedName: name,
      cachedPicture: picture
    };

    let p1 = invitation_send_to_existing_user({ // also send an email
      type:            'Goal',
      payload:         invitationPayload,
      personalMessage: 'Automatic Invitation',
      sendCopy:        false,
      receiverUserId:  contactUserId,
      receiverEmail:   null,
    })

    // Add other user to goal
    let p2 = goal_add_member({
      goal_id: sharedGoalId,
      user_id: contactUserId,
      data: {
        isAdmin: true,
        // TODO: Other user data !!
      }
    })

    // Set shared goal id for other user
    let p3 = $userContact
      .with({ uid: contactUserId })
      .update(senderUserId, {
        sharedGoalId: sharedGoalId,
      })

    // Set shared goal id for me
    let p4 = $userContact
      .update(contactUserId, {
        sharedGoalId: sharedGoalId,
      })

    return Promise.all([p1, p2, p3, p4]).then(() => {
      return sharedGoalId;
    })
  })
}

export function contact_create_shared_commitment({ name, sharedGoalId, contactUserId }) {

  console.log("contact_create_shared_commitment", name, sharedGoalId, contactUserId)

  // 1. check if one exists
  // 2. create goal if necessary
  // 3. create commitment
  // 4. write ids into my contact info
  // 4. write ids into other users contact info

  /*
  let commitment = $api.commitment_model_new({
    type: 'TASKLIST',
    goal_id: goalId,
  });
  // commitment.picture = ...
  // commitment.meta.assignedUserId
  commitment.meta.name = 'First steps';
  commitment.user.$id = contactUserId;
  commitment.write_with_meta().then((commitmentId) => {

  });
  */

  const picture = 'https://images.pexels.com/photos/128756/pexels-photo-128756.jpeg?auto=compress&cs=tinysrgb&fit=crop&h=627&w=1200';

  return commitment_create({
    type: 'TASKLIST',
    goal_id: sharedGoalId,
    data: {
      picture: picture,
      name: name,
      memberId: contactUserId,
    }
  }).then((results) => {

    let otherUserCommitmentId = results[0];
    console.log("Got otherUserCommitmentId", results)

    let p1 = $userContact
      .with({ uid: contactUserId })
      .update(contactUserId, {
        // sharedGoalId: sharedGoalId,
        sharedIncommingCommitmentId: null,
        // sharedOutgoingCommitment: null,
      })

    let p2 = $userContact
      .update(contactUserId, {
        // sharedGoalId: sharedGoalId,
        sharedIncommingCommitmentId: otherUserCommitmentId,
        // sharedOutgoingCommitment: null,
      })

    return Promise.all([p1, p2]).then(() => {
      return otherUserCommitmentId;
    })
  })
}

// -----------------------------------------------------------------------------
export async function contact_create_shared_goal_and_commitment_if_necessary({
  contactId
}) {

  let myUserId        = $models.user.defaultUserId;
  let contactInfo     = await $models.userContact.getNode( contactId );
  let myUserStatus    = await $models.userContact.get_contact_by_id( myUserId );
  let otherUserStatus = await $models.userContact.get_contact_by_id( contactId );

  let nameA = otherUserStatus.displayName;
  let nameB = myUserStatus.displayName;

  // TODO: Check if goal and commitment still exist

  // Do I have a shared goal with this user? If not create one
  if ( !contactInfo.sharedGoalId ) {

    // TODO: Also check my contact info, if goal already exists!

    contactInfo.sharedGoalId = await contact_create_shared_goal({
        name:          `Shared goal: ${nameA} and ${nameB}`,
        contactUserId: contactId,
      })
  }

  console.log("STEP 1:", contactInfo)

  // Do I have a shared commitment with this user? If not create one
  if ( !contactInfo.sharedIncommingCommitmentId ) {
    contactInfo.sharedIncommingCommitmentId = await contact_create_shared_commitment({
        name:          `${nameA}' Tasks`,
        sharedGoalId:  contactInfo.sharedGoalId,
        contactUserId: contactId,
      });
  }

  console.log("STEP 2:", contactInfo)

  return contactInfo;
}

// -----------------------------------------------------------------------------
export async function contact_send_task_copy({
  receiverUserId,
  message,
  goalId,
  taskId,
  memberId,
}) {

  // Created a shared goal / commitment if necessary
  let { sharedGoalId, sharedIncommingCommitmentId } = await
    contact_create_shared_goal_and_commitment_if_necessary({ contactId: receiverUserId })

  // Don't allow sending a copy of a task that comes from a shared goal
  // It would be better to check, if commitment is the same (sharedIncommingCommitmentId === commitmentId),
  // but we don't have the commitmentId here.
  if ( sharedGoalId === goalId ) {
    // code: 'copy-from-shared-goal',
    throw new Error('This task already belongs to a shared goal. Copying is not supported.');
  }

  let dstTaskId = await task_assign_to_goal({
    src_goal_id: goalId,       // ok
    dst_goal_id: sharedGoalId, // ok
    src_commitment_id: null,   // not required 8
    dst_commitment_id: sharedIncommingCommitmentId, // ok
    src_member_id: memberId,   // ok
    dst_member_id: receiverUserId,  // ok
    task_id: taskId,           // ok
    copy: true,
  })

  // ...then send the task
  return contact_send_existing_task({
    receiverUserId: receiverUserId, // ok
    message:        message,   // ok
    taskId:         dstTaskId, // ok
    memberId:       receiverUserId, // ok
    goalId:         sharedGoalId,
    commitmentId:   sharedIncommingCommitmentId, // REMOVE
  })
}

// -----------------------------------------------------------------------------
export async function contact_send_new_task({
  receiverUserId,
  message = ""
}) {

  // Created a shared goal / commitment if necessary
  let { sharedGoalId, sharedIncommingCommitmentId } = await
    contact_create_shared_goal_and_commitment_if_necessary({ contactId: receiverUserId })

  // Create a task
  let taskId = await task_create_user({
    goal_id:   sharedGoalId,
    parent_id: sharedIncommingCommitmentId,
    member_id: receiverUserId,
    data: {
      sortidx: Math.random() // HACK !!! get_last_sortidx, won't work
    }
  });

  // ...then send the task
  return contact_send_existing_task({
    receiverUserId: receiverUserId,
    message:        message,
    taskId:         taskId,
    memberId:       receiverUserId,
    goalId:         sharedGoalId,
    commitmentId:   sharedIncommingCommitmentId, // REMOVE
  })
}

// -----------------------------------------------------------------------------
export function contact_send_existing_task({
  receiverUserId,
  message,
  taskId,
  goalId,
  memberId,
  commitmentId,
}) {

  if ( !util.isValidId( taskId ) ) {
    throw new Error('Invalid taskId: ' + taskId)
  }

  if ( !util.isValidId( goalId ) ) {
    throw new Error('Invalid goalId: ' + goalId)
  }

  if ( !util.isValidId( commitmentId ) && commitmentId !== null) { // REMOVE
    throw new Error('Invalid commitmentId: ' + commitmentId)
  }

  if ( !util.isValidId( memberId ) && memberId !== 'TEAM' ) {
    throw new Error('Invalid memberId: ' + memberId)
  }

  let data = {
    type: 'TASK',
    taskId: taskId,
    goalId: goalId,
    memberId: memberId,
    commitmentId: commitmentId, // REMOVE
  }

  return contact_send_message({ receiverUserId, message, data });
}

// -----------------------------------------------------------------------------
export function contact_send_message({ receiverUserId, message, data = {} }) {

  if ( message === undefined) {
    throw new Error('Invalid message: ' + message)
  }

  if ( !util.isValidId( receiverUserId ) ) {
    throw new Error('Invalid receiverUserId: ' + receiverUserId)
  }

  let senderUserId = $models.user.defaultUserId;

  // Increase update count (in other users contact info)
  $userContact
    .with({ uid: receiverUserId })
    .transaction(
      senderUserId,
      'numNewMessages',
      'inc', 1 );

  return $models.userMsgInbox
    .with({ uid: receiverUserId })
    .add({ senderUserId, message, ...data })
}

// -----------------------------------------------------------------------------
export function contact_delete_message({ messageId, receiverUserId = null, }) {
  console.log("contact_delete_message", receiverUserId, messageId);

  receiverUserId = receiverUserId || $models.user.defaultUserId
  return $models.userMsgInbox.with({ uid: receiverUserId }).remove( messageId )
}

// -----------------------------------------------------------------------------
// TODO: contact_load_if_not_cached
export function contact_add_if_not_cached( userId ) {
  // console.log("contact_add_if_not_cached", userId)
  return $models.userStatus.subscribeNode( userId )
}

// ---------------------------------------------------------------------------
/* See: https://stackoverflow.com/questions/38618953/how-to-do-a-simple-search-in-string-in-firebase-database
   and: https://angularfirebase.com/lessons/autocomplete-search-with-angular4-and-firebase/*/
export function contact_query_by_string(queryString, limit = 10) {

  /*
  // TODO: check:
  query.orderByKey &&
  query.limitToFirst <= 100 &&
  query.startAt.length > 3 && query.startAt.contains('@') &&
  query.endAt.length > 3 && query.endAt.contains('@')",
  */

  return new Promise((resolve, reject) => {
    $models.userdirectory.buildQueryRef({
      // key:  'email',
      key:     'searchfield',
      startAt: queryString.toLowerCase(),
      endAt:   queryString.toLowerCase() + "\uf8ff",
      limit:   limit
    }).once('value', match => {
      let result = match.val();

      if ( !result ) {
        resolve([{ value: 'No match' }]);
        return
      }

      let users = []
      Object.keys(result).forEach(key => {
        users.push( $models.userPublic.fetchNode( result[key].userId ) )
      })

      Promise.all(users.map(user => user.$promise)).then(() => {
        let userlist = users.map(user => {
          let displayName = user.firstName + ' ' + user.lastName;
          if ( !user.firstName && !user.lastName) {
            displayName = 'Unknown'
          }
          return {
            id:          user.$id, // required for el-tag in search field
            $id:         user.$id,
            $key:        user.$id + Math.random(), // HACK
            value:       user.$id,
            label:       displayName,
            profilePic:  user.profilePic,
            // displayName: displayName
          }
        })

        resolve(userlist);
      })

      /* let userlist = Object.keys(result).map(key => {
        let item = result[key];
        return {
          id:          key,
          value:       item.email,
          profilePic:  item.profilePic,
          displayName: item.displayName ? item.displayName : 'N/A',
          email:       item.email
        };
      })
      resolve(userlist); */
    })
  })

  // console.log("contact_query_by_string", queryString);
  /*
    oldRealTimeDb
      .ref("/status/")
      .orderByChild('email')
      .startAt(queryString)
      .endAt(queryString + "\uf8ff")
      .limitToFirst(50)
      //.on('value', match => {
      .once('value', match => {})
  */
}

// -----------------------------------------------------------------------------
export function contact_send_direct_chat_message({ text, toUserId }) {
  return contact_send_message({ message: text, receiverUserId: toUserId });
}
